
export class AmountFormatterUtils {

    /**
     * Checks if a string is a valid number for the current language (decimalSplitter). By default it will only accept 2 decimal digits.
     * Returns the number as number is everything is fine if not null.
     */
    public static verifyDecimalNumber( sNum: string, lang: string, decimalCount?: number ): number {
        let decimalSplitter = '.';
        let thousandSplitter = ',';

        // switch the right splitters for the language
        if ( lang === 'de' ) {
            decimalSplitter = ',';
            thousandSplitter = '.';
        }

        if ( !decimalCount ) {
            decimalCount = 2;
        }

        // test regex (starts with digit(s) followed by optional <decimalSplitter> and up to <decimalCount> digits)
        let regex = RegExp( '^$|^\\d+(\\' + decimalSplitter + '\\d{0,' + decimalCount + '})?$' );
        if ( !regex.test( sNum ) ) {
            return null;    // did not pass regex
        }

        // replace decimalSplitter in german
        if ( lang === 'de' ) {
            sNum = sNum.replace( decimalSplitter, thousandSplitter );
        }
        return parseFloat( sNum );  // passed regex
    }

    /**
     * Formats a given number to a string containing the correct decimalSplitter
     */
    public static formatDecimalNumber( num: number, lang: string ): string {
        if ( !num ) {
            return '';
        }
        let sNum = String( num );
        let splitArray = sNum.split( '.' );
        if ( splitArray[1] ) {
            if ( splitArray[1].length < 2 ) {
                splitArray[1] = splitArray[1] + '00';
            }
        } else {
            splitArray[1] = '00';
        }
        sNum = splitArray[0] + '.' + splitArray[1].substring( 0, 2 );

        if ( lang === 'de' ) {
            // replace decimalSplitter
            sNum = sNum.replace( '.', ',' );
        }

        return sNum;
    }
}
